import productPreview from "../assets/product-preview-dark.png"
import DownloadEmailForm from "./DownloadEmailForm"

const Hero = () => {
    return (
        <div className="relative bg-gradient-to-b from-white to-gray-50 overflow-hidden">
            {/* Container */}
            <div className="relative z-10 max-w-4xl mx-auto px-6 pt-24 pb-4 text-center">
                
                {/* Headline */}
                <h1 className="text-5xl font-bold tracking-tight text-gray-900 mb-6">
                    Find anything. <span className="text-blue-600">Instantly.</span>
                </h1>

                {/* Subheadline */}
                <p className="text-xl text-gray-600 max-w-2xl mx-auto mb-10">
                Search your <span className="font-medium text-gray-800">Google Drive + Mac files</span> from one lightning fast command bar.  
                Stop switching apps - Sentivo brings everything together.
                </p>

                {/* CTA */}
                {/* <button className="px-8 py-4 rounded-xl bg-black text-white text-lg font-medium shadow-xl hover:shadow-2xl hover:bg-gray-900 transition-all">
                Get Early Access →
                </button> */}
                <div className="flex flex-col items-center pt-6 space-y-4">
                    <DownloadEmailForm 
                        downloadUrl="https://pub-6f7c3d3ca81344b2ac370e1a84d731b4.r2.dev/Sentivo.dmg"
                        buttonLabel="Download for Mac"
                        className="max-w-xl mx-auto lg:mx-0"
                    />
                            
                    {/* <p className="self-start text-sm text-gray-500 text-center lg:text-left">
                        <span className="font-semibold text-blue-600">Limited beta spots available.</span>{" "}
                    </p> */}
                </div>
            </div>

            {/* Floating screenshot */}
            <div className="flex justify-center">
                <img
                src={productPreview} 
                alt="Sentivo App Screenshot"
                className="w-[800px]"
                                
                />
            </div>
        </div>
        // <section className="relative min-h-screen flex flex-col items-center justify-center bg-gradient-to-b from-white via-blue-50/30 to-white px-4 sm:px-6 lg:px-8 pt-24 pb-16">

        //     <div className="max-w-7xl mx-auto w-full">
        //         <div className="grid lg:grid-cols-2 gap-12 items-center">

        //             <div className="text-center lg:text-left space-y-6">

        //                 <h1 className="text-5xl sm:text-6xl lg:text-5xl font-semibold text-gray-900 leading-tight tracking-tight max-w-xl">
        //                     One search bar for your{" "}
        //                     <span className="text-blue-600">entire digital life</span>
        //                 </h1>
                        
        //                 <p className="text-xl sm:text-xl text-gray-600 leading-relaxed max-w-2xl mx-auto lg:mx-0">
        //                     Unify file search in one place. Find everything instantly.
        //                 </p>

        //                 <div className="pt-6 space-y-4">
        //                     <DownloadEmailForm 
        //                         downloadUrl="https://pub-6f7c3d3ca81344b2ac370e1a84d731b4.r2.dev/Sentivo.dmg"
        //                         buttonLabel="Download for Mac"
        //                         className="max-w-xl mx-auto lg:mx-0"
        //                     />
                            
        //                     <p className="text-sm text-gray-500 text-center lg:text-left">
        //                         <span className="font-semibold text-blue-600">Limited beta spots available.</span>{" "}
        //                     </p>
        //                 </div>
        //             </div>

        //             <div className="relative flex items-center justify-center">
        //                 <div className="relative w-full max-w-2xl">
        //                         <img 
        //                             src={productPreview} 
        //                             alt="Sentivo app in use - unified search interface"
        //                             className="w-full h-auto rounded-2xl shadow-xs"
        //                         />
        //                 </div>
        //             </div>
        //         </div>
        //     </div>
        // </section>
    )
}

export default Hero